import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'xom-modal-layout',
  templateUrl: './modal-layout.component.html',
  styleUrls: ['./modal-layout.component.scss']
})
export class ModalLayoutComponent implements OnInit {

  @Input() hasHeader = false;
  @Input() large = false;

  constructor() { }

  ngOnInit() {
  }

}
